"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var border = require('./border');
var iconDesktopSizes = require('./iconDesktopSizes');
var iconMobileSizes = require('./iconMobileSizes');
var layers = require('./layers');
var media = require('./media');
var shadow = require('./shadow');
var spacing = require('./spacing');
var alias = require('./alias');
module.exports = (0, _extends2.default)({
  border: border,
  iconDesktopSizes: iconDesktopSizes,
  iconMobileSizes: iconMobileSizes,
  layers: layers,
  media: media,
  shadow: shadow,
  spacing: spacing
}, alias);